// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

/* 路由 */
import router from './router'

/* axios */
// import axios from './api'
// import api from './api/api'
// Vue.prototype.http = axios;
// Vue.prototype.api = api;

Vue.use(ViewUI)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'
//
import './assets/css/iconfont.css'
import 'video.js/dist/video-js.css';
import hls from 'videojs-contrib-hls';

Vue.use(hls)

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

import './assets/css/main.css'
/* 头部组件 */
import Header from './components/Header'

Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'

Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'

Vue.component(GoTop.name, GoTop)

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

Vue.config.productionTip = false

import $ from 'jquery'

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});

new Vue({
  el: '#app',
  router,
  components: {App},
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js